'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = {
  inkDisabled: _propTypes2["default"].bool,
  inkDisabledInteractions: _propTypes2["default"].arrayOf(_propTypes2["default"].oneOf(['keyboard', 'mouse', 'touch']))
};